import React, {useEffect, useRef, useState} from "react";
import {UsersService} from "../services/UsersService";
import withRouter from "../components/WithRouter";
import Loader from "../components/Loader";
import FormGroup from "../components/FormGroup";
import Select from "react-select";
import {DepartmentService} from "../services/DepartmentService";
import {useParams} from "react-router-dom";
import {InputText} from "primereact/inputtext";
import {useFormik} from "formik";
import {useSelector} from "react-redux";
import {Toast} from "primereact/toast";
import {Dropdown} from "primereact/dropdown";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";

export default function UserEditMoney() {

    const props = useParams()
    const toast = useRef(null);

    const additionals_values_variant = {
        'single': '1 занятие',
        'salary': '1 месяц',
        'procent': '%'
    }

    const [loaded, setLoaded] = useState(false)
    const [cash, setCash] = useState(false)
    const [services, setServices] = useState([])
    const [additionals, setAdditionals] = useState([])
    const [groups, setGroups] = useState([])
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });

    const handleAddAdditional = (e) => {
        setServices(servicesFormik.values.concat([{value: '', additional_id: '', group_id: '', type: 'additional'}]))
        // setFormData({...formData, services: services.concat([{value: '', additional_id: '', group_id: '', type: 'additional'}])})
        e.preventDefault()
    }

    const handleAddMainAdditional = (e) => {
        setServices(servicesFormik.values.concat([{value: '', additional_id: '', group_id: '', type: 'kindergarten'}]))
        // setFormData({...formData, services: services.concat([{value: '', additional_id: '', group_id: '', type: 'kindergarten'}])})
        e.preventDefault()
    }


    const handleAddIndividual = (e) => {
        setServices(servicesFormik.values.concat([{value: '', additional_id: '', cash_type: '', type: 'individual'}]))
        // setFormData({...formData, services: services.concat([{value: '', additional_id: '', group_id: '', type: 'individual'}])})
        e.preventDefault()
    }

    const cashFormik = useFormik({
        validate: () => {

        },
        onSubmit: (data) => {
            setLoaded(false)
            UsersService.SaveCash(props.userId, localStorage.getItem('currentDepartment'), data).then((response) => {
                if (!response.errors) {
                    toast.current.show({severity: 'success', summary: 'Данные успешно сохранены!'});
                } else {
                    toast.current.show({severity: 'error', summary: 'Ошибка!'});
                }
                setLoaded(true)
            })
        }
    })

    const servicesFormik = useFormik({
        validate: () => {

        },
        onSubmit: (data) => {
            setLoaded(false)
            UsersService.SaveServices(props.userId, localStorage.getItem('currentDepartment'), data).then((response) => {
                toast.current.show({severity: 'success', summary: 'Данные успешно сохранены!'});
                setLoaded(true)
            })
            // UsersService.SaveCash(props.userId, localStorage.getItem('currentDepartment'), data).then((response) => {
            //     if (!response.errors) {
            //         toast.current.show({severity: 'success', summary: 'Данные успешно сохранены!'});
            //     } else {
            //         toast.current.show({severity: 'error', summary: 'Ошибка!'});
            //     }
            //     setLoaded(true)
            // })
        }
    })


    useEffect(() => {
        setLoaded(false)
        UsersService.GetCash(props.userId, localStorage.getItem('currentDepartment')).then((response) => {
            if (response.items.length) {
                setCash(response.items[0])
            } else {
                setCash({
                    rate: '',
                    advance_cash: '',
                    advance_bank: '',
                    salary_cash: '',
                    salary_bank: '',
                    prize: '',
                    processing_price: ''
                })
            }
            setLoaded(true)
        })
        UsersService.GetServices(props.userId, localStorage.getItem('currentDepartment')).then((response) => {
            setServices(response.items)
        })
        DepartmentService.getGroups({'filter': {'department_id': localStorage.getItem('currentDepartment')}}).then((response) => {
            setGroups(response.items)
        })
        DepartmentService.getAdditionals({'filter': {'department_id': localStorage.getItem('currentDepartment')}}).then((response) => {
            setAdditionals(response.items)
        })
        // setLoaded(true)
    }, [currentDepartment]);

    useEffect(() => {
        if (cash) {
            cashFormik.setValues({cash: cash})
        }
        if (services) {
            console.log(services)
            servicesFormik.setValues(services)
        }
    }, [cash, services])


    const handleRemoveAdditional = (number) => {

        confirmDialog({
            message: 'Вы хотите удалить?',
            header: 'Подтвердите удаление',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: () => {
                let c = servicesFormik.values;
                delete c[number]
                servicesFormik.setValues(c)
            },
            acceptLabel: 'Да',
            reject: () => {return false},
            rejectLabel: 'Нет'
        });
    }


    console.log(servicesFormik.values)

    return (
        <>
            <Toast ref={toast}></Toast>
            <ConfirmDialog />
            {loaded && cashFormik.values ?
                <>
                    <div className="card">

                        <div className="card-body">
                            <form action="#" className={'theme-form'} onSubmit={cashFormik.handleSubmit}>

                                <h3 className={'m-b-30'}>Зарплата</h3>
                                <FormGroup label={"Ставка ₽"}>
                                    <InputText value={cashFormik.values.cash.rate}
                                               onChange={(e) => cashFormik.setFieldValue('cash.rate', e.target.value)}/>
                                </FormGroup>

                                <div className="row">

                                    <div className="col">
                                        <FormGroup label={'Аванс кеш ₽'}>
                                            <InputText value={cashFormik.values.cash.advance_cash}
                                                       onChange={(e) => cashFormik.setFieldValue('cash.advance_cash', e.target.value)}/>

                                        </FormGroup>
                                    </div>
                                    <div className="col">
                                        <FormGroup label={'Аванс безнал ₽'}>
                                            <InputText value={cashFormik.values.cash.advance_bank}
                                                       onChange={(e) => cashFormik.setFieldValue('cash.advance_bank', e.target.value)}/>

                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">

                                    <div className="col">
                                        <FormGroup label={'Зарплата кеш ₽'}>

                                            <InputText value={cashFormik.values.cash.salary_cash}
                                                       onChange={(e) => cashFormik.setFieldValue('cash.salary_cash', e.target.value)}/>

                                        </FormGroup>
                                    </div>
                                    <div className="col">
                                        <FormGroup label={'Зарплата безнал ₽'}>
                                            <InputText value={cashFormik.values.cash.salary_bank}
                                                       onChange={(e) => cashFormik.setFieldValue('cash.salary_bank', e.target.value)}/>

                                        </FormGroup>
                                    </div>
                                </div>

                                <div className="row">

                                    <div className="col">
                                        <FormGroup label={'Премия ₽'}>

                                            <InputText value={cashFormik.values.cash.prize}
                                                       onChange={(e) => cashFormik.setFieldValue('cash.prize', e.target.value)}/>

                                        </FormGroup>
                                    </div>
                                    <div className="col">
                                        <FormGroup label={'Час переработки ₽'}>
                                            <InputText value={cashFormik.values.cash.processing_price}
                                                       onChange={(e) => cashFormik.setFieldValue('cash.processing_price', e.target.value)}/>

                                        </FormGroup>
                                    </div>
                                </div>

                                <button type={'submit'} className={'btn btn-primary'}>Сохранить</button>
                            </form>
                        </div>
                    </div>


                    <div className="card">

                        <div className="card-body">

                            <form className="theme-form" onSubmit={servicesFormik.handleSubmit}>
                                <h3 className={'m-b-30'}>Факультативы</h3>

                                {servicesFormik.values && servicesFormik.values.map((el, k) => {


                                    if (el.type === 'kindergarten') {

                                        return (
                                            <div className={'row m-b-10 align-items-center'}>
                                                <div className="col">
                                                    <Dropdown
                                                        options={(groups && groups.map((option) => {
                                                            return {label: option.name, value: option.id}
                                                        }))}
                                                        value={el.group_id}
                                                        placeholder={'Группа'}
                                                        onChange={(e) => servicesFormik.setFieldValue(k+'.group_id', e.target.value)}
                                                    />
                                                </div>
                                                <div className="col">
                                                    <Dropdown
                                                        options={(additionals && additionals.filter((option) => {
                                                            return option.type === 'kindergarten'
                                                        }).map((option) => {
                                                            return {label: option.name, value: option.id}
                                                        }))}
                                                        value={el.additional_id}
                                                        placeholder={'Факультатив'}
                                                        onChange={(e) => servicesFormik.setFieldValue(k+'.additional_id', e.target.value)}
                                                    />

                                                </div>
                                                <div className="col">
                                                    <InputText value={el.value} onChange={(e) => servicesFormik.setFieldValue(k + '.value', e.target.value)} placeholder={'Сумма'}/>
                                                </div>
                                                <div className="col">
                                                    <Dropdown
                                                        options={(additionals_values_variant && Object.entries(additionals_values_variant).map((option) => {
                                                            return {label: option[1], value: option[0]}
                                                        }))}
                                                        value={el.cash_type}
                                                        placeholder={'Тип оплаты'}
                                                        onChange={(e) => servicesFormik.setFieldValue(k+'.cash_type', e.target.value)}
                                                    />
                                                </div>
                                                {
                                                    el.id && <div className={'col col-auto'}>
                                                        <button type={'button'} className={'btn btn-light'} onClick={() => handleRemoveAdditional(k)}>
                                                            <i className={'pi pi-trash'}></i>
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                        )
                                    }
                                })}


                                <a href="#" className={'btn btn-light'} onClick={handleAddMainAdditional}>Добавить</a>


                                {/*<hr/>*/}
                                <h3 className={'m-b-30 m-t-30'}>Доп. занятия</h3>


                                {servicesFormik.values.map((el, k) => {

                                    if (el.type === 'additional') {

                                        return (
                                            <div className={'row m-b-10'}>
                                                <div className="col">
                                                    <Dropdown
                                                        options={(additionals && additionals.filter((option) => {
                                                            return option.type === 'additional'
                                                        }).map((option) => {

                                                                return {label: option.name, value: option.id}
                                                        }))}
                                                        value={el.additional_id}
                                                        placeholder={'Предмет'}
                                                        onChange={(e) => servicesFormik.setFieldValue(k+'.additional_id', e.target.value)}
                                                    />
                                                </div>
                                                <div className="col">
                                                    <InputText value={el.value} onChange={(e) => servicesFormik.setFieldValue(k + '.value', e.target.value)} placeholder={'Сумма'}/>
                                                </div>
                                                <div className="col">
                                                    <Dropdown
                                                        options={(additionals_values_variant && Object.entries(additionals_values_variant).map((option) => {
                                                            return {label: option[1], value: option[0]}
                                                        }))}
                                                        value={el.cash_type}
                                                        placeholder={'Тип оплаты'}
                                                        onChange={(e) => servicesFormik.setFieldValue(k+'.cash_type', e.target.value)}
                                                    />
                                                </div>
                                                {
                                                    el.id && <div className={'col col-auto'}>
                                                        <button type={'button'} className={'btn btn-light'} onClick={() => handleRemoveAdditional(k)}>
                                                            <i className={'pi pi-trash'}></i>
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                        )
                                    }
                                })}

                                <a href="#" className={'btn btn-light'} onClick={handleAddAdditional}>Добавить</a>
                                {/*<hr/>*/}
                                <h3 className={'m-b-30 m-t-30'}>Индивид. занятия</h3>


                                {servicesFormik.values.map((el, k) => {

                                    if (el.type === 'individual') {

                                        return (
                                            <div className={'row m-b-10'}>
                                                <div className="col">
                                                    <Dropdown
                                                        options={(additionals && additionals.filter((option) => {
                                                            return option.type === 'individual'
                                                        }).map((option) => {

                                                            return {label: option.name, value: option.id}
                                                        }))}
                                                        value={el.additional_id}
                                                        placeholder={'Предмет'}
                                                        onChange={(e) => servicesFormik.setFieldValue(k+'.additional_id', e.target.value)}
                                                    />
                                                </div>
                                                <div className="col">
                                                    <InputText value={el.value} onChange={(e) => servicesFormik.setFieldValue(k + '.value', e.target.value)} placeholder={'Сумма'}/>
                                                </div>
                                                <div className="col">
                                                    <Dropdown
                                                        options={(additionals_values_variant && Object.entries(additionals_values_variant).map((option) => {
                                                            return {label: option[1], value: option[0]}
                                                        }))}
                                                        value={el.cash_type}
                                                        placeholder={'Тип оплаты'}
                                                        onChange={(e) => servicesFormik.setFieldValue(k+'.cash_type', e.target.value)}
                                                    />
                                                </div>
                                                {
                                                    el.id && <div className={'col col-auto'}>
                                                        <button type={'button'} className={'btn btn-light'} onClick={() => handleRemoveAdditional(k)}>
                                                            <i className={'pi pi-trash'}></i>
                                                        </button>
                                                    </div>
                                                }


                                            </div>
                                        )
                                    }
                                })}

                                <a href="#" className={'btn btn-light'} onClick={handleAddIndividual}>Добавить</a>

                                <div className="d-flex text-end m-t-30">
                                    <button type={'submit'} className={'btn btn-primary m-r-10'}>Сохранить</button>

                                </div>


                            </form>

                        </div>
                    </div>
                </>
                : <Loader/>}
        </>
    )


}